import React from 'react';
import { styled } from '@linaria/react';
import { ResetSectionPadding } from 'components/Accommodation/AccommodationView/Mobile/styles';
import { ReviewsTrackClick, SelectedElementType } from 'components/Accommodation/DateGuestInput/ReviewsTrackClick';
import { GuestTypeBadge } from 'components/Accommodation/GuestTypeBadge';
import { GuestType } from 'types/Hotel';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { HorizontalScroll } from '@daedalus/atlas/helpers/HorizontalScroll';
import { Text } from '@daedalus/atlas/Text';
import { Entity } from '@daedalus/core/src/analytics/types/Events';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { calculateGuestTypePercentages } from './utils';
type Props = {
  guestType: GuestType;
};
const _exp = /*#__PURE__*/() => ResetSectionPadding;
const HorizontalScrollWrapper = /*#__PURE__*/styled(_exp())({
  name: "HorizontalScrollWrapper",
  class: "hyk140w",
  propsAsIs: true
});
export const GuestTypesSubSection = ({
  guestType
}: Props) => {
  const {
    isMobile
  } = useDeviceLayout();
  if (!guestType) return null;
  const guestTypePercentages = calculateGuestTypePercentages(guestType);
  return <>
      <ReviewsTrackClick stopPropagation element={SelectedElementType.GuestTypesHeader} entity={Entity.HotelDetailsReviewsSection}>
        <ContentWrapper paddingBottom="s500">
          <Text variant="titleM">
            <FormattedMessageWrapper id="reviews.whoStaysHere" defaultMessage="Who stays here?" />
          </Text>
        </ContentWrapper>
      </ReviewsTrackClick>
      <HorizontalScrollWrapper>
        <HorizontalScroll columnGap={isMobile ? 's600' : 's700'}>
          {guestTypePercentages.map(({
          key,
          value
        }) => <GuestTypeBadge key={key} guestTypeKey={key} value={value} />)}
        </HorizontalScroll>
      </HorizontalScrollWrapper>
    </>;
};

require("./GuestTypesSubSection.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./GuestTypesSubSection.tsx");